import { Checkbox as AntCheckbox, CheckboxProps as CheckboxPropsBase } from 'antd';
import styled from 'styled-components';

import { BodilColor } from '~src/branding';
import { IconProps } from '~src/model';

type CheckboxSize = 'default' | 'large';

type StyleProps = { highlight?: boolean; size?: CheckboxSize };

const StyleWrapper = styled.div<Pick<CheckboxProps, 'checked'> & StyleProps>(({ size, highlight, checked }) => ({
  '.ant-checkbox-inner': {
    borderColor: highlight && !checked ? BodilColor.base.default : undefined,
    width: size === 'large' ? '24px' : undefined,
    height: size === 'large' ? '24px' : undefined,
    '::after': {
      left: size === 'large' ? '33%' : undefined,
    },
  },
}));

export type CheckboxProps = Omit<IconProps, 'onClick'> & CheckboxPropsBase & StyleProps;

export const Checkbox = ({ checked, onChange, style, highlight, size, disabled }: CheckboxProps) => {
  return (
    <StyleWrapper {...{ checked, highlight, size }}>
      <AntCheckbox {...{ checked, onChange, style, disabled: disabled ?? !onChange }} />
    </StyleWrapper>
  );
};
